
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalogsearch/result/[query]",
      function () {
        return require("private-next-pages/catalogsearch/result/[query].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalogsearch/result/[query]"])
      });
    }
  